import ReactDOM from "react-dom";


import Navbar from "./Navbar";
import Body from "./Body";

import { useState, useEffect } from "react";
import { ToastContainer } from 'react-toastify';


const App = () => {
  
  
  const [coordinates, setCoordinates] = useState({});
  
  
  
  const [type, setType] = useState('restaurants');
 
  const [autocomplete, setAutocomplete] = useState(null);
  const [rating, setRating] = useState(0);
  const [arrivalDate, setArrivalDate] = useState("");
  const [bounds, setBounds] = useState({});


  
      
      
      
      
    
  // }, [type, bounds]);

  const onLoad = (autoC) => {
    setAutocomplete(autoC);
  };
  const onPlaceChanged = () => {

    const lat = autocomplete.getPlace().geometry?.location.lat();
    const lng = autocomplete.getPlace().geometry?.location.lng();
    if(lat && lng){
    setCoordinates({lat:lat,lng:lng})
    setBounds({ne: { lat: lat + 0.1, lng: lng + 0.1 }, sw: { lat: lat - 0.1, lng: lng - 0.1 } });
    }
    
  };

  return (
    <>
      {/* {console.log("coordinates", coordinates)}
      {console.log("Bonds", bounds)} */}
      <Navbar onLoad={onLoad} onPlaceChanged={onPlaceChanged} setType={setType} rating={rating} setRating={setRating} arrivalDate={arrivalDate} setArrivalDate={setArrivalDate}   /><ToastContainer />
      <Body coordinates={coordinates} setCoordinates={setCoordinates}   type={type} setType={setType} rating={rating} setRating={setRating} arrivalDate={arrivalDate} bounds={bounds} setBounds={setBounds}    />
      
    </>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
